import { LiabilityService } from '../../services/liability.service';
import { ToolbarService } from 'src/app/core/services/toolbar.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FakeProgress } from 'src/app/shared/utils/fake-progress';
import { tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UploadedFile } from '../../models/uploaded-file.model';
import { HandsetService } from 'src/app/core/services/handset.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

const FAKE_PROGRESS_DURATION_MS = 30000;
const FAKE_PROGRESS_LIMIT = 95;
const MANUAL_INPUT_DELAY = 60000;

@Component({
  standalone: false,
  selector: 'app-file-reading',
  styleUrls: ['./file-reading.component.scss'],
  templateUrl: './file-reading.component.html',
})
export class FileReadingComponent implements OnInit, OnDestroy {
  public file: UploadedFile;
  public unsubscribe = new Subject();

  public progress: FakeProgress;
  public urlSafe: SafeResourceUrl;
  public displayManualInputBtn = false;
  protected automaticReadingId: string;

  constructor(
    public handsetService: HandsetService,
    private route: ActivatedRoute,
    private toolbar: ToolbarService,
    private liabilityService: LiabilityService,
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {
    this.toolbar.init(this.route);
    this.automaticReadingId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.liabilityService
      .getAutomaticReadingFileUrl(this.automaticReadingId)
      .pipe(
        tap((fileUrl: string) => {
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
        }),
      )
      .subscribe();

    this.progress = new FakeProgress(FAKE_PROGRESS_DURATION_MS, FAKE_PROGRESS_LIMIT);
    this.progress.start();

    setTimeout(() => {
      this.displayManualInputBtn = true;
    }, MANUAL_INPUT_DELAY);
  }

  cancelAndGoToManualInput() {
    this.liabilityService
      .deleteAutomaticReading(this.automaticReadingId)
      .pipe(tap(() => this.router.navigate(['/liabilities/add/manual'])))
      .subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this.progress.stop();
  }

  onGoToAllLiabilities() {
    this.router.navigateByUrl('/liabilities/all');
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
